/* eslint-disable react/require-default-props */
import React, { useRef, useState } from 'react';
import { Container } from './styles';

interface Props {
  title: string;
  onFileSelect?: (file: File | null) => void;
}

const UploadCard: React.FC<Props> = ({ title, onFileSelect }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0] || null;
    setFile(selected);
    onFileSelect?.(selected);
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    setFile(null);
    onFileSelect?.(null);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    if (file) return;
    const dropped = e.dataTransfer.files?.[0] || null;
    setFile(dropped);
    onFileSelect?.(dropped);
  };

  return (
    <Container>
      <div className="card mb-4">
        <div className="card-body">
          <h5 className="mb-4">{title}</h5>
          <div
            className={`upload-area d-flex align-items-center justify-content-center ${
              file ? 'has-file' : ''
            } ${isDragging ? 'dragging' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => !file && inputRef.current?.click()}
            onKeyDown={(e) => {
              if ((e.key === 'Enter' || e.key === ' ') && !file) {
                inputRef.current?.click();
              }
            }}
            onDragOver={(e) => e.preventDefault()}
            onDragEnter={(e) => {
              e.preventDefault();
              setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
          >
            {!file ? (
              <div className="text-center upload-placeholder">
                <div className="upload-icon mb-2">
                  <i className={`fas ${isDragging ? 'fa-download' : 'fa-upload'}`} />
                </div>
                <span className="text-primary font-weight-medium">
                  {isDragging
                    ? 'Solte o arquivo aqui'
                    : 'Clique para selecionar ou arraste os arquivos aqui'}
                </span>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-between w-100 px-3">
                <div className="d-flex align-items-center">
                  <span className="mr-3 file-icon">📄</span>
                  <div>
                    <strong>{file.name}</strong>
                    <div className="text-muted small">
                      {(file.size / 1024 / 1024).toFixed(2)} MB
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-link text-danger p-0"
                  onClick={handleRemove}
                >
                  ×
                </button>
              </div>
            )}
            <input
              ref={inputRef}
              type="file"
              hidden
              accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default UploadCard;
